module.exports = __webpack_public_path__ + "img/xbox-3.0f530fbd.png";